import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const mainText = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: 1.5,
  color: grey[800],
};

export default makeStyles((theme) => ({
  tabsContainer: {
    marginBottom: theme.spacing(2),
    justifyContent: "center",
  },
  tabLabel: {
    textTransform: "none",
    minWidth: 0,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    color: grey[800],
    fontSize: "16px",
    fontWeight: 400,
  },
  infoBox: {
    ...mainText,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.shape.borderRadius,
    paddingBlock: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  infoIcon: {
    color: theme.palette.primary.main,
    marginInline: theme.spacing(2),
  },
  infoText: {
    ...mainText,
  },
  input: {
    backgroundColor: "white",
  },
}));
